import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { AreaUnitEnum } from 'src/enumerators';
import { OrganizationService } from '../services';

/**
 * Formata a área persistida da região/demarcação (`totalArea`, sempre em m²)
 * conforme a preferência da organização corrente (`OrganizationService.organization.areaUnit`).
 *
 * - `km2` (padrão): converte m² → km² (÷ 1.000.000) e exibe com rótulo `km²`.
 * - `m2`: mantém em m² e exibe com rótulo `m²`.
 *
 * Sempre com 3 casas decimais (padrão de tela). NÃO altera o valor cru usado em
 * cálculo/ordenação — apenas a exibição.
 */
@Pipe({
  name: 'area',
  pure: false,
})
export class AreaPipe implements PipeTransform {
  constructor(
    private readonly organizationService: OrganizationService,
    @Inject(LOCALE_ID) private readonly locale: string,
  ) {}

  transform(totalArea: number | null | undefined): string {
    const areaInM2 = Number(totalArea ?? 0);

    const areaUnit = this.organizationService?.organization?.areaUnit ?? AreaUnitEnum.km2;

    if (areaUnit === AreaUnitEnum.m2) {
      return `${formatNumber(areaInM2, this.locale, '1.3-3')} m²`;
    }

    const areaInKm2 = areaInM2 / 1_000_000;
    return `${formatNumber(areaInKm2, this.locale, '1.3-3')} km²`;
  }
}
